import Store from 'store/store';

export const IMAGE_REGION_ROOT_DYNAMIC = '%IMAGE_REGION_ROOT_DYNAMIC%';

export function useDynamicAssetFolder(path) {
	if (!path || typeof path !== 'string') {
		return path;
	}
	const store = Store.get();
	const imageRegionRoot = store?.appData?.urls?.roots?.imageRegion;
	let newRoot = imageRegionRoot;

	// assetUpdateDateTime soon to be legacy, dynamicAssetUpdate is the new way
	const assetUpdateDateTime = store?.appData?.options?.useAssetUpdateDateTime;
	const dynamicAssetUpdate = store?.appData?.options?.dynamicAssetUpdate;

	if (dynamicAssetUpdate?.useDynamicUpdates) {
		const dynamicDateTimes = Object.values(dynamicAssetUpdate?.dateTimesForUpdates).sort((a, b) => a - b);
	
		let updateNum = 0;
		dynamicDateTimes.forEach((datetime) => {
			if (Date.now() > datetime) {
				updateNum++;
			}
		});
		if (updateNum > 0) {
			newRoot += `/updates${updateNum}`;
		}
	} else if (assetUpdateDateTime && (Date.now() > assetUpdateDateTime)) {
		newRoot += '/updates';
	}
	
	return path.replace(/%IMAGE_REGION_ROOT_DYNAMIC%/g, newRoot);
}
